import { render } from "./CredentialsDisplay.vue?vue&type=template&id=2655c0ce&scoped=true"
import script from "./CredentialsDisplay.vue?vue&type=script&lang=js"
export * from "./CredentialsDisplay.vue?vue&type=script&lang=js"

import "./CredentialsDisplay.vue?vue&type=style&index=0&id=2655c0ce&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2655c0ce"]])

export default __exports__